export default __webpack_public_path__ + "static/media/audiooff.9d1cb139.svg";